import React, { useState } from "react";
import Header from "../../../Components/Header";
import Sidebar from "../../../Components/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { db } from "../../../config/firebase";
import { collection, addDoc } from "firebase/firestore";
import { uploadFile } from "../../../firebase/storageService";
import ImageUpload from "../../../Components/ImageUpload";
import { toast, ToastContainer } from "react-toastify";
import FeatherIcon from "feather-icons-react";
import 'react-toastify/dist/ReactToastify.css';

const AddService = () => {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePreview, setImagePreview] = useState('');

    const handleImageLoad = (event, id) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreview(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        try {
            let imageUrl = '';
            
            // Upload image if selected
            if (selectedFile) {
                const toastId = toast.loading("Uploading partner logo...");
                try {
                    const imagePath = `partners/${Date.now()}-${selectedFile.name}`;
                    await uploadFile(selectedFile, imagePath);
                    imageUrl = imagePath;
                    toast.update(toastId, { 
                        render: "Logo uploaded successfully!", 
                        type: "success", 
                        isLoading: false, 
                        autoClose: 2000 
                    });
                } catch (error) {
                    toast.update(toastId, { 
                        render: "Logo upload failed: " + error.message, 
                        type: "error", 
                        isLoading: false, 
                        autoClose: 2000 
                    });
                    throw error;
                }
            }

            await addDoc(collection(db, "partners"), {
                name: name,
                imageUrl: imageUrl,
                createdAt: new Date()
            });

            sessionStorage.setItem('addPartnerSuccess', 'true');
            navigate("/serviceslist");
        } catch (error) {
            toast.error('Error adding partner: ' + error.message);
            console.error('Error adding partner: ', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <Sidebar
                id="menu-item4"
                id1="menu-items4"
                activeClassName="services"
            />
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/serviceslist">Partners</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right">
                                            <FeatherIcon icon="chevron-right" />
                                        </i>
                                    </li>
                                    <li className="breadcrumb-item active">Add Partner</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-heading">
                                                    <h4>Add Partner</h4>
                                                </div>
                                            </div>

                                            {/* Name */}
                                            <div className="col-12 col-md-6 col-xl-6">
                                                <div className="form-group local-forms">
                                                    <label>
                                                        Partner Name <span className="login-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        disabled={loading}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            {/* Partner Logo Upload */}
                                            <div className="col-12">
                                                <div className="form-group local-forms">
                                                    <label>Partner Logo</label>
                                                    <div className="row">
                                                        <ImageUpload 
                                                            id="partner-logo" 
                                                            src={imagePreview} 
                                                            loadFile={handleImageLoad} 
                                                            imageName="Partner Logo" 
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Submit/Cancel Button */}
                                            <div className="col-12">
                                                <div className="form-action-group text-end">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary submit-form me-2"
                                                        disabled={loading}
                                                    >
                                                        {loading ? "Adding Partner..." : "Add Partner"}
                                                    </button>
                                                    <Link to="/serviceslist">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary cancel-form"
                                                            disabled={loading}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <ToastContainer />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddService;
